module.exports = __webpack_public_path__ + "img/pt.8ce156e0.svg";